
import { defineComponent, shallowRef, computed } from 'vue'

// Composables
import { useTitle } from '@vueuse/core'
import { injectForceReload } from '@/use/force-reload'
import { useNotifChannels, NotifChannel, NotifChannelType } from '@/alerting/use-notif-channels'

// Components
import ForceReloadBtn from '@/components/ForceReloadBtn.vue'
import NotifChannelNewMenu from '@/alerting/NotifChannelNewMenu.vue'
import NotifChannelSlackForm from '@/alerting/NotifChannelSlackForm.vue'
import NotifChannelTelegramForm from '@/alerting/NotifChannelTelegramForm.vue'
import NotifChannelWebhookForm from '@/alerting/NotifChannelWebhookForm.vue'
import NotifChannelAlertmanagerForm from '@/alerting/NotifChannelAlertmanagerForm.vue'
import NotifChannelsTable from '@/alerting/NotifChannelsTable.vue'

export default defineComponent({
  name: 'ChannelList',
  components: {
    ForceReloadBtn,
    NotifChannelNewMenu,
    NotifChannelSlackForm,
    NotifChannelTelegramForm,
    NotifChannelWebhookForm,
    NotifChannelAlertmanagerForm,
    NotifChannelsTable,
  },

  setup() {
    useTitle('Notification Channels')
    const forceReload = injectForceReload()

    const channels = useNotifChannels(() => {
      return forceReload.params
    })

    const internalDialog = shallowRef(false)
    const activeChannel = shallowRef<NotifChannel>()
    const dialog = computed({
      get(): boolean {
        return Boolean(internalDialog.value && activeChannel.value)
      },
      set(dialog: boolean) {
        internalDialog.value = dialog
        if (!dialog) {
          activeChannel.value = undefined
        }
      },
    })

    return {
      NotifChannelType,

      channels,

      dialog,
      activeChannel,
    }
  },
})
